import Vue from 'vue'
import App from './App.vue'
import router from './router'
import messages from './message.json'
import VueI18n from 'vue-i18n'
import { applyLegacyStaticConfig } from './config'
import { applyRootFontSize, resolveLayoutDevice } from './utils/device'
import { applyInviteFromLocation } from './utils/channel'
import { rememberVisit } from './utils/visitFlow'
import { initCrisp } from './utils/crisp'

Vue.config.productionTip = false
Vue.use(VueI18n)

applyLegacyStaticConfig()
applyInviteFromLocation()
rememberVisit()

Vue.prototype.device = resolveLayoutDevice()
applyRootFontSize(Vue.prototype.device)

const i18n = new VueI18n({
  locale: 'zh',
  messages,
})

new Vue({
  router,
  render: h => h(App),
  i18n,
}).$mount('#app')

initCrisp()
